<template>
  <div id="Header">
    <!-- <div id="title">
      <span>Wyszukiwarka</span>
    </div> -->
    <div id="nav-header">

      <div id="nav-orientation" style="">
        <button @click="changePosition('vertical')" :class="(bnActivPosition == 'vertical') ? 'activ-button' : ''" style="margin-right: 6px;">{{ $t("pionowo") }}</button>
        <button @click="changePosition('horizontal')" :class="(bnActivPosition == 'horizontal') ? 'activ-button' : ''">{{ $t("poziomo") }}</button>
        <button v-if="bnActivPosition == 'horizontal'" @click="showFilters()" style="margin: 0px 20px;" class="addFiltr">{{ $t("btn_show_filtry") }}</button>
        <!-- <button @click="changePosition('horizontal-more')" :class="(bnActivPosition == 'horizontal-more') ? 'activ-button' : ''">poziomo więcej</button> -->
      </div>
      <div id="nav-sort" style="display: inline-flex; min-width: 410px;">
        <div style="margin-left: 0px; line-height: 34px;">
          <label style="color: white;">{{ $t("sortuj_po") }}</label>
          <select v-model="sortKey" style="width: 165px;  background: white;  border: none;  border-radius: 4px;  padding: 3px 10px;">
            <option value="symbol">{{ $t("symbol") }}</option>
            <option value="netto_asc">{{ $t("cena_asc") }}</option>
            <option value="netto_desc">{{ $t("cena_dsc") }}</option>
          </select>

        <!-- <button @click="toggleSortOrder" style="margin: 0px;">
          {{ sortOrder === 'asc' ? '⬆️ ' + $t("rosnaco") : '⬇️ ' + $t("malejaco") }}
        </button> -->
        </div>
        <div style="max-width: 274px;  line-height: 34px;  margin-left: 30px;  color: white;">
          {{ $t("results") }}:
          <span>
            <b>{{ count_products }}</b>
            <!-- <b>{{ list_products.length }}</b> -->
          </span>
        </div>
      </div>

    </div>

    <md-dialog :md-active.sync="showDialog">
      <md-dialog-actions>
        <md-button style="min-width: 30px; background: burlywood;" @click="showDialog = false">X</md-button>
      </md-dialog-actions>
      <md-dialog-title>{{ $t("pokaz_ukryj_filtry") }}</md-dialog-title>
      <md-dialog-content style="width: 575px;">
        <ul v-if="tree && bnActivPosition == 'vertical'">
          <li v-for="(attr,attrIndex) in Object.keys(tree)" :key="attr">
            <label :for="'attr'+attrIndex"></label>
            <!-- {{attr}} -->
            <input type="checkbox" :name="'attr'+attrIndex" v-model="dataInputs" :value="attr" @change="onChangeCheckBox">
            <span class="card-value">{{(list_attributes[attr] && list_attributes[attr].translation) ? list_attributes[attr].translation : (attr['translation']) ? attr['translation'] : attr}}</span>
          </li>
        </ul>
        <!-- horizontal -->
        <ul v-else style="list-style: none;">
          <li v-for="(attr, index) in Object.keys(tree)" :key="attr">
            <label :for="'attr-'+index"></label>
            <input type="checkbox" :name="'attr-'+index" v-model="dataInputs" :value="attr" @change="onChangeCheckBox">
            <span class="card-value">
              <i v-if="tree[attr] && tree[attr]['translation']">{{tree[attr]['translation']}}</i>
            </span>
          </li>
        </ul>
      </md-dialog-content>
    </md-dialog>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import { auth } from '../../mixins/auth'
// import { helpers } from '../../mixins/helpers'

export default {
  name: 'Header',
  // props: ['title'],
  // mixins: [auth, helpers],
  data () {
    return {
      bnActivPosition: 'vertical',
      showDialog: false,
      dataInputs: []
      // userLog: true,
      // dataPage: {}
    }
  },
  computed: {
    ...mapGetters('products', ['tree','list_attributes', 'selectedFilters',"count_products"]),
    filtrList() {
      return this.dataInputs
    },
    sortKey: {
      get() {
        return this.$store.state.products.sortKey; // lub getter jeśli masz
      },
      set(value) {
        this.$store.commit('products/SET_SORT_KEY', value);
      }
    }
  },
  watch: {
    showDialog (newValue) {
      if (newValue) {
        this.changeDataInputs()
      }
    }
  },
  methods: {
    // changeSortKey() {
    //   // Tutaj możesz dodać dodatkową logikę, np. ponowne sortowanie produktów
    //   this.$store.dispatch('products/sortProducts', this.sortKey);
    // },
    changePosition (e) {
      this.bnActivPosition = e
      this.$store.commit('products/SET_POSITION_FILTERS', e)
    },
    showFilters () {
      this.showDialog = true
      console.log('show modul')
    },
    onChangeCheckBox () {
      this.$store.commit('products/SET_SELECTED_FILTERS', this.dataInputs)
    },
    changeDataInputs () {
      this.dataInputs = this.selectedFilters
    }
  },
  created () {
    if (this.selectedFilters && this.selectedFilters.length>0) {
      this.dataInputs = JSON.parse(JSON.stringify(this.selectedFilters))
    }
  }
}
// styl do radiobuttonów
// document.documentElement.style.setProperty(
//   '--md-theme-default-accent',
//   '#6dff09'
// )
</script>

<style lang="css" scoped>
#Header {
  width: 100%;
  background: rgb(12, 95, 204) none repeat scroll 0% 0% !important;
  /* background: slategray; */
  display: block;
  /* box-shadow: 0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12); */
}
#nav-header {
  text-align: left;
  width: 100%;
  height: 36px;
  background: #929292;
  display: flex;
}
#nav-header button {
  margin:0px;
  padding: 0px;
  background: white;
  border-radius: 5px;
  border: none;
  cursor: pointer;
}
#nav-header button.activ-button {
  background: rgb(88, 88, 88);
  color: white;
}
#nav-orientation {
  height: 36px;
  min-width: 305px;
  margin-left: 20px;
  width: 30%;
  max-width: 410px;
}
#nav-orientation button {
  margin-top: 6px;
  padding: 4px 10px;
}
#nav-sort {
  height: 36px;
}
.addFiltr {
  color: black;
}
.addFiltr:hover {
  background: rgb(88, 88, 88) !important;
  color: white;
  cursor: pointer;
}
#title {
  font-size: 25px;
  color: white;
  height: 64px;
  width: 100%;
  background: #585858;
}
#title span {
  line-height: 40px;
}
.activ-button {
  background: green;
}
.container {
  max-width: 100% !important;
  width: 100%;
  padding: 0px;
  margin: 0px;
}
.row {
  height:64px
}
.md-button {
  background: #8d50bd !important;
  /* background: #8da1b4 !important */
}
#radioBtn {
  width: 420px;
  margin: 0px auto;
  color: white;
}
h1 {
  font-size: 1.2em;
  text-align: center;
  font-weight: 700;
}
.version {
  font-size: 0.6em;
  text-align: center;
}
.clause {
  font-size: 0.6em;
  text-align: center;
}
@media only screen and (max-width: 830px) {
  #nav-header {
    display: block;
    height: 72px;
  }
  #nav-sort[data-v-61dd7a3d] {
    margin-left: 20px;
  }
  .home .row {
    display: block;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue